module.exports = territoryDefinition;